<template>
  <no-navbar />
</template>

<script>
import NoNavbar from '@/portal/layouts/NoNavbar.vue';

export default {
  name: 'maintenance',
  components: {
    NoNavbar,
  },
};
</script>
